import { Box, SxProps } from "@outschool/backpack";
// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import React from "react";

type CardProps = {
  sx?: SxProps;
  children: any;
  [prop: string]: any;
};

export const Card: React.ForwardRefExoticComponent<CardProps> =
  React.forwardRef(({ sx, children, ...rest }, ref) => {
    return (
      <Box
        ref={ref}
        sx={[
          {
            background: "white",
            boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.16)",
            borderRadius: "0.5em",
            marginTop: "2em",
            marginBottom: "2em",
            padding: "2em",
          },
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
        {...rest}
      >
        {children}
      </Box>
    );
  });

export default Card;
